import type { ApiPlatform } from '@shared-core/services/api'
import { isMobilePwa } from '@web/libs/platform/pwa'
import { isTMA } from '@web/libs/tg/platform'

export { isMobilePwa } from '@web/libs/platform/pwa'

export function resolveWebApiPlatform(): ApiPlatform {
  if (isTMA()) return 'tma'

  if (isMobilePwa()) return 'pwa'

  return 'web'
}
